<script lang="ts">
    import {onMount} from "svelte";

    export let href = null;
    export let isOtherTab = false;

    $: rel = (() => {
        if (isOtherTab) {
            return 'noopener noreferrer';
        } else {
            return '';
        }
    })();

    $: target = (() => {
        if (isOtherTab) {
            return '_blank';
        } else {
            return '';
        }
    })();

    onMount(() => {
    });


</script>

{#if href != null}
    <a href={href} rel={rel} target={target}>
        <slot/>
    </a>
{:else}
    <slot/>
{/if}

